export const APPLY_PROMO_CODE_REQUEST = "APPLY_PROMO_CODE_REQUEST";
export const APPLY_PROMO_CODE_SUCCESS = "APPLY_PROMO_CODE_SUCCESS";
export const APPLY_PROMO_CODE_ERROR = "APPLY_PROMO_CODE_ERROR";

export const CLEAR_PROMO_CODE_FLAG = "CLEAR_PROMO_CODE_FLAG";